import { QueryCache, QueryClient, QueryClientProvider } from "@tanstack/react-query";
import type React from "react";

import { HttpResponseSchemaMismatchError } from "~/services/http";

import { useHandleGlobalErrors } from "./global-error-provider";

let queryClient: QueryClient | null = null;

export function DefaultQueryClientProvider({ children }: { children: React.ReactNode }) {
  const setError = useHandleGlobalErrors();
  const client = getQueryClient(setError);

  return <QueryClientProvider client={client}>{children}</QueryClientProvider>;
}

function getQueryClient(setError: ReturnType<typeof useHandleGlobalErrors>) {
  queryClient ||= new QueryClient({
    defaultOptions: {
      queries: {
        retry: (failureCount, error) => {
          if (error instanceof HttpResponseSchemaMismatchError) return false;
          return failureCount < 3;
        },
        throwOnError: (error) => {
          if (error instanceof HttpResponseSchemaMismatchError) return true;

          return false;
        },
      },
      mutations: {
        throwOnError: (error) => {
          if (error instanceof HttpResponseSchemaMismatchError) return true;

          return false;
        },
      },
    },
    queryCache: new QueryCache({
      onError: (error: any, query) => {
        const onError = query.meta?.onError;

        if (onError) {
          onError(error);
        } else {
          setError({ error });
        }
      },
    }),
  });

  return queryClient;
}
